/* ORZO, nowy wygląd 2026-10-17: zakładki menu, karuzela imprez, zdjęcia lokali w banerze,
   karta podarunkowa i kolor wybranej restauracji. Bez tego pliku strona dalej działa. */
(function () {
  var d = document, still = matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Kolor restauracji: na stronie lokalu od wejścia, gdzie indziej po kliknięciu „Rezerwuj” przy lokalu.
  var root = d.documentElement;
  function kolor(c, fg) { if (!c) return; root.style.setProperty('--acc', c); root.style.setProperty('--acc-fg', fg || '#0B0B0B'); d.body.classList.add('n-v'); }
  var start = d.body.getAttribute('data-n-c');
  if (start) kolor(start, d.body.getAttribute('data-n-fg'));
  d.addEventListener('click', function (e) {
    var a = e.target.closest('[data-venue]'); if (!a) return;
    var c = a.closest('[style*="--c"]'); if (!c) return;
    var v = getComputedStyle(c).getPropertyValue('--c').trim();
    var fg = a.getAttribute('data-venue').indexOf('blu') === 0 ? '#FFFFFF' : '#0B0B0B';
    kolor(v === '#FCE300' ? '#C9A800' : v, fg);
  });

  // Baner: najechanie na nazwę lokalu pokazuje jego zdjęcie
  var row = d.querySelector('.nh-row');
  if (row && matchMedia('(hover: hover)').matches) {
    var sl = d.querySelectorAll('.nh-s');
    row.querySelectorAll('[data-nh]').forEach(function (a) {
      a.addEventListener('mouseenter', function () {
        sl.forEach(function (s) { s.classList.toggle('on', s.getAttribute('data-s') === a.getAttribute('data-nh')); });
        row.querySelectorAll('a').forEach(function (x) { x.classList.toggle('on', x === a); });
      });
    });
    row.addEventListener('mouseleave', function () { sl.forEach(function (s) { s.classList.remove('on'); }); row.querySelectorAll('a').forEach(function (x) { x.classList.remove('on'); }); });
  }

  // Zakładki menu
  d.querySelectorAll('.nm-tabs').forEach(function (tabs) {
    var bs = tabs.querySelectorAll('[role="tab"]');
    bs.forEach(function (b) {
      b.addEventListener('click', function () {
        bs.forEach(function (x) { var on = x === b; x.setAttribute('aria-selected', on); var p = d.getElementById(x.getAttribute('aria-controls')); if (p) p.hidden = !on; });
      });
    });
  });

  // Karuzela imprez
  d.querySelectorAll('.ne').forEach(function (s) {
    var it = s.querySelectorAll('.ne-i'), tb = s.querySelectorAll('.ne-tabs [data-ne]'), nav = s.querySelector('.ne-nav'), cnt = s.querySelector('.ne-cnt'), cur = 0;
    if (it.length < 2) return;
    s.classList.add('js-ne'); if (nav) nav.hidden = false;
    function show(i) {
      cur = (i + it.length) % it.length;
      it.forEach(function (x, k) { x.classList.toggle('on', k === cur); });
      tb.forEach(function (x, k) { x.setAttribute('aria-selected', k === cur); });
      if (cnt) cnt.textContent = (cur + 1) + ' / ' + it.length;
    }
    tb.forEach(function (b, k) { b.addEventListener('click', function () { show(k); }); });
    s.querySelectorAll('[data-ne-k]').forEach(function (b) { b.addEventListener('click', function () { show(cur + (+b.getAttribute('data-ne-k'))); }); });
    var x0 = null;
    s.querySelector('.ne-list').addEventListener('pointerdown', function (e) { x0 = e.clientX; });
    s.querySelector('.ne-list').addEventListener('pointerup', function (e) { if (x0 == null) return; var dx = e.clientX - x0; x0 = null; if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1)); });
    var h = location.hash.replace('#', '');
    if (h) tb.forEach(function (b, k) { if ((b.textContent || '').toLowerCase().indexOf(h.replace(/-/g, ' ')) > -1) show(k); });
  });

  // Karta podarunkowa
  d.querySelectorAll('.ng').forEach(function (s) {
    var amt = s.querySelector('[data-ng-amt]'), card = s.querySelector('.ng-card');
    s.querySelectorAll('[data-ng]').forEach(function (c) {
      c.addEventListener('click', function () {
        s.querySelectorAll('[data-ng]').forEach(function (x) { x.setAttribute('aria-pressed', x === c); });
        amt.classList.add('sw'); setTimeout(function () { amt.textContent = c.getAttribute('data-ng') + ' zł'; amt.classList.remove('sw'); }, 180);
      });
    });
    if (!still && matchMedia('(hover: hover)').matches && card) {
      var st = s.querySelector('.ng-stage');
      st.addEventListener('pointermove', function (e) { var r = card.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height; card.style.transition = 'transform .15s linear'; card.style.setProperty('--ry', ((x - .5) * 14) + 'deg'); card.style.setProperty('--rx', ((.5 - y) * 12) + 'deg'); });
      st.addEventListener('pointerleave', function () { card.style.transition = ''; card.style.setProperty('--ry', '0deg'); card.style.setProperty('--rx', '0deg'); });
    }
  });
})();
